import a from "./contact-channels84.js";
function i(r, e) {
  a(r);
  var t = /^\s+/g;
  return r.replace(t, "");
}
export {
  i as default
};
//# sourceMappingURL=contact-channels87.js.map
